/* eslint-disable */
import React, { useEffect, useContext, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";

import VatOptions from "data/Invoice/VAT.json";
import * as url from "helper/UrlHelper";
import { getData, postData } from "utils/Gateway";
import { useTranslation } from "react-i18next";
import { getCurrentDateInString } from "helper/getcurrentdatestring";
import { reactSelectStyle } from "Config/Config";

const AddNewCrmOpportunityPopup = ({
  moudleSlug = "",
  afterPopupClose = () => {},
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const opportunityTypeOptions = [
    { label: t("Lead"), value: "lead" },
    { label: t("Contact"), value: "contact" },
  ];

  const [selectedOppotunityType, setSelectedOppotunityType] = useState(null);
  const [invoiceModuleName, setInvoiceModuleName] = useState("");
  const [leadInput, setleadInput] = useState("");
  const [contactInput, setcontactInput] = useState("");
  const [leadOptions, setleadOptions] = useState([]);
  const [contactOptions, setcontactOptions] = useState([]);
  const [followersInput, setFollowersInput] = useState("");
  const [followersOptions, setFollowersOptions] = useState([]);
  const [invoiceLeadValue, setinvoiceLeadValue] = useState(null);
  const [invoiceLeadId, setinvoiceLeadId] = useState(null);
  const [invoiceContactValue, setinvoiceContactValue] = useState(null);
  const [invoiceContactId, setinvoiceContactId] = useState(null);
  const [invoiceContactPersonId, setinvoiceContactPersonId] = useState(null);
  const [title, settitle] = useState("");
  const [description, setdescription] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [promisePercent, setpromisePercent] = useState("");
  const [followersValue, setFollowersValue] = useState(null);
  const [selctedFollowers, setSelectedFollowers] = useState([]);
  const [totalTax, setTotalTax] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  const [invoiceOwnerId, setinvoiceOwnerId] = useState(null);
  const [newLeadName, setnewLeadName] = useState("");
  const [newLeadEmail, setnewLeadEmail] = useState("");
  const [newLeadPhone, setnewLeadPhone] = useState("");

  const invoiceItemTemplate = {
    _id: null,
    description: "",
    quantity: 0,
    price: 0,
    discountpercent: 0,
    discount: 0,
    taxpercent: 0,
    tax: 0,
    amount: 0,
    taxselectedvalue: null,
  };

  const [invoiceItemsList, setInvoiceItemsList] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [errors, setErrors] = useState({});

  // requirements of leads/contacts
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [emailAddress, setemailAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [company, setcompany] = useState("");
  const [position, setposition] = useState("");
  const [address, setaddress] = useState("");
  const [city, setcity] = useState("");
  const [state, setstate] = useState("");
  const [country, setcountry] = useState("");
  const [zipcode, setzipcode] = useState("");

  const validateForm = () => {
    const newErrors = {};

    if (!selectedOppotunityType) {
      newErrors.type = t("Please select an opportunity type.");
    }

    if (
      selectedOppotunityType &&
      !invoiceLeadValue &&
      !invoiceContactValue &&
      (!newLeadName.trim() || !newLeadEmail.trim())
    ) {
      newErrors.selection = t(
        "Please select an existing lead/contact or provide details for a new one (Name and Email are required)."
      );
    }

    if (!title.trim()) {
      newErrors.title = t("Opportunity title is required.");
    }

    if (!totalAmount || totalAmount <= 0) {
      newErrors.price = t(
        "Total amount must be calculated and greater than zero."
      );
    }

    if (!promisePercent || promisePercent <= 0) {
      newErrors.percent = t("Promise percent must be a positive value.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const opportunityTypeSelectionHandler = (val) => {
    if (errors.type) {
      setErrors((prev) => ({ ...prev, type: "" }));
    }
    if (val) {
      setSelectedOppotunityType(val);
      setInvoiceModuleName(val.value);
    } else {
      setSelectedOppotunityType(null);
      setInvoiceModuleName("");
      setleadInput("");
      setcontactInput("");
      setleadOptions([]);
      setcontactOptions([]);
      setinvoiceLeadId(null);
      setinvoiceLeadValue(null);
      setinvoiceContactId(null);
      setinvoiceContactValue(null);
      setinvoiceContactPersonId(null);
      setErrors((prev) => ({ ...prev, selection: "" }));
    }
  };

  const leadInputChangeHandler = (val) => setleadInput(val);
  const contactInputChangeHandler = (val) => setcontactInput(val);
  const onFollowersInputChange = (val) => setFollowersInput(val);

  const getLeadOptions = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_LEAD_OPTIONS}?token=${token}&leadstringinput=${leadInput}`;
      const response = await getData(requestUrl);
      if (response.status) setleadOptions(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getContactOptions = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_CONTACTS_OPTIONS}?token=${token}&userstring=${contactInput}`;
      const response = await getData(requestUrl);
      if (response.status) setcontactOptions(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getFollowersOptions = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_USERLIST_OPTIONS}?token=${token}&userstringinput=${followersInput}`;
      const response = await getData(requestUrl);
      if (response.status) setFollowersOptions(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const leadSelectionHandler = (val) => {
    if (errors.selection) {
      setErrors((prev) => ({ ...prev, selection: "" }));
    }
    if (val) {
      setinvoiceLeadValue(val);
      setinvoiceLeadId(val.value);
      getLeadDetails(val.value);
    } else {
      setinvoiceLeadValue(null);
      setinvoiceLeadId(null);
      setleadInput("");
      setleadOptions([]);
      setfirstName("");
      setlastName("");
      setemailAddress("");
      setPhoneNumber("");
      setDateOfBirth("");
      setcompany("");
      setposition("");
      setaddress("");
      setcity("");
      setstate("");
      setcountry("");
      setzipcode("");
    }
  };

  const contactSelectionHandler = (val) => {
    if (errors.selection) {
      setErrors((prev) => ({ ...prev, selection: "" }));
    }
    if (val) {
      setinvoiceContactValue(val);
      setinvoiceContactId(val._id);
      setinvoiceContactPersonId(val.value);
      getContactUserDetails(val.value);
    } else {
      setinvoiceContactValue(null);
      setinvoiceContactId(null);
      setinvoiceContactPersonId(null);
      setcontactInput("");
      setcontactOptions([]);
      setfirstName("");
      setlastName("");
      setemailAddress("");
      setPhoneNumber("");
      setDateOfBirth("");
      setcompany("");
      setposition("");
      setaddress("");
      setcity("");
      setstate("");
      setcountry("");
      setzipcode("");
    }
  };

  const followersSelectionHandler = (val) => {
    if (val) {
      setFollowersValue(val);
      setSelectedFollowers(val.map((item) => item.value));
    } else {
      setFollowersValue(null);
      setSelectedFollowers([]);
      setFollowersInput("");
      setFollowersOptions([]);
    }
  };

  const addNewInvoiceItem = () =>
    setInvoiceItemsList([...invoiceItemsList, invoiceItemTemplate]);

  const onDeleteInvoiceItem = (index) => {
    const deletedItemBlock = [...invoiceItemsList];
    deletedItemBlock.splice(index, 1);
    setInvoiceItemsList(deletedItemBlock);
  };

  const changeInvoiceItemsInputs = (index, field, value) => {
    const updatedFormValues = invoiceItemsList.map((block, i) =>
      index === i ? { ...block, [field]: value } : block
    );
    setInvoiceItemsList(updatedFormValues);
    updateItemGrossValues(index, updatedFormValues);
  };

  const taxSelectionHandler = (index, val) => {
    const updatedFormValues = invoiceItemsList.map((block, i) =>
      index === i
        ? { ...block, taxselectedvalue: val, taxpercent: val.value }
        : block
    );
    setInvoiceItemsList(updatedFormValues);
    updateItemGrossValues(index, updatedFormValues);
  };

  const invoiceItemUpdateHandler = () => {
    const totalAmount = invoiceItemsList.reduce(
      (amount, item) => amount + item.price * item.quantity,
      0
    );
    const totalTax = invoiceItemsList.reduce((tax, item) => tax + item.tax, 0);
    const totalDiscount = invoiceItemsList.reduce(
      (discount, item) => discount + item.discount,
      0
    );
    const payableAmount = invoiceItemsList.reduce(
      (total, item) => total + item.amount,
      0
    );

    setTotalAmount(totalAmount);
    setTotalTax(totalTax);
    setTotalDiscount(totalDiscount);
    setPayableAmount(payableAmount);

    if (totalAmount > 0 && errors.price) {
      setErrors((prev) => ({ ...prev, price: "" }));
    }
  };

  const updateItemGrossValues = (index, items) => {
    const currentItems = items || invoiceItemsList;
    const updatedItems = [...currentItems];
    const quantity = parseInt(updatedItems[index].quantity, 10) || 0;
    const price = parseInt(updatedItems[index].price, 10) || 0;
    const tax = parseInt(updatedItems[index].taxpercent, 10) || 0;

    if (quantity > 0 && price > 0) {
      const taxToPay = (quantity * price * tax) / 100;
      const totalPrice = quantity * price + taxToPay;
      updatedItems[index].tax = taxToPay;
      updatedItems[index].amount = totalPrice;
      setInvoiceItemsList(updatedItems);
    }
  };

  const saveInvoice = async () => {
    if (!validateForm()) {
      return;
    }

    setIsSaving(true);
    let invoiceData = {
      title,
      description,
      amount: totalAmount,
      promisepercent: promisePercent,
      followers: selctedFollowers,
      invoicedate: getCurrentDateInString(),
      duedate: getCurrentDateInString(),
      totaltax: totalTax,
      totaldiscount: totalDiscount,
      payableamount: payableAmount,
      currency: "euro",
      items: invoiceItemsList,
      status: "1",
      notes: [],
      typeslug: moudleSlug || "opportunity",
      modulename: invoiceModuleName,
    };

    if (invoiceLeadValue || invoiceContactValue) {
      invoiceData.leadid = invoiceLeadId;
      invoiceData.contactid = invoiceContactId;
      invoiceData.clientid = invoiceContactPersonId;
    } else {
      let leadData = { email: newLeadEmail, phone: newLeadPhone };
      const leadName = newLeadName.split(" ").filter(Boolean);
      leadData.name = leadName[0] || "";
      leadData.surname = leadName.slice(1).join(" ") || "";
      const leadRequestUrl = `${url.API_BASE_URL}${url.API_CREATE_LEAD}?token=${token}`;
      const leadResponse = await postData(leadRequestUrl, leadData);
      if (leadResponse.status) {
        invoiceData.leadid = leadResponse.data._id;
      }
    }

    try {
      const requestUrl = `${url.API_BASE_URL}${url.API_CREATE_INVOICE}?token=${token}`;
      const response = await postData(requestUrl, invoiceData);
      setIsSaving(false);
      if (response.status) {
        setMessageType("success");
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#addNewInvoice")
        ).hide();
        resetHandler();
        afterPopupClose([response.data]);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const resetHandler = () => {
    setErrors({});
    setSelectedOppotunityType(null);
    setInvoiceModuleName("");
    setleadInput("");
    setcontactInput("");
    setleadOptions([]);
    setcontactOptions([]);
    setinvoiceLeadId(null);
    setinvoiceLeadValue(null);
    setinvoiceContactId(null);
    setinvoiceContactValue(null);
    setinvoiceContactPersonId(null);
    setnewLeadName("");
    setnewLeadEmail("");
    setnewLeadPhone("");
    settitle("");
    setdescription("");
    setpromisePercent("");
    setInvoiceItemsList([invoiceItemTemplate]);
    setTotalAmount(0);
    setTotalTax(0);
    setPayableAmount(0);
    setFollowersInput("");
    setFollowersOptions([]);
    setFollowersValue(null);
    setSelectedFollowers([]);
    setfirstName("");
    setlastName("");
    setemailAddress("");
    setPhoneNumber("");
    setDateOfBirth("");
    setcompany("");
    setposition("");
    setaddress("");
    setcity("");
    setstate("");
    setcountry("");
    setzipcode("");
  };

  const getLeadDetails = async (leadId) => {
    if (!leadId) return;
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_LEAD_DETAILS}/${leadId}?token=${token}`;
      const response = await getData(requestUrl);
      if (response.status) {
        const {
          name,
          surname,
          email,
          phone,
          dob,
          company,
          position,
          address,
          city,
          state,
          country,
          zipcode,
        } = response.data;
        setfirstName(name);
        setlastName(surname);
        setemailAddress(email);
        setPhoneNumber(phone);
        setDateOfBirth(
          dob && dob.includes("-") ? dob.split("-").reverse().join("-") : ""
        );
        setcompany(company || "");
        setposition(position || "");
        setaddress(address || "");
        setcity(city || "");
        setstate(state || "");
        setcountry(country || "");
        setzipcode(zipcode || "");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getContactUserDetails = async (userId) => {
    if (!userId) return;
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_USER_DETAILS}/${userId}?token=${token}`;
      const response = await getData(requestUrl);
      if (response.status && response.data) {
        const {
          name,
          surname,
          email,
          phone,
          dob,
          company,
          position,
          address,
          city,
          state,
          country,
          zipcode,
        } = response.data;
        setfirstName(name);
        setlastName(surname);
        setemailAddress(email);
        setPhoneNumber(phone);
        setDateOfBirth(
          dob && dob.includes("-") ? dob.split("-").reverse().join("-") : ""
        );
        setcompany(company || "");
        setposition(position || "");
        setaddress(address || "");
        setcity(city || "");
        setstate(state || "");
        setcountry(country || "");
        setzipcode(zipcode || "");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (invoiceItemsList.length === 0) addNewInvoiceItem();
  }, []);

  useEffect(invoiceItemUpdateHandler, [invoiceItemsList]);
  useEffect(() => {
    if (leadInput.length > 0) getLeadOptions();
  }, [leadInput]);
  useEffect(() => {
    if (contactInput.length > 0) getContactOptions();
  }, [contactInput]);
  useEffect(() => {
    if (followersInput.length > 0) getFollowersOptions();
  }, [followersInput]);

  // Custom styles for members
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.type || errors.selection ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.type || errors.selection ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  return (
    <div
      className="offcanvas invoice_w offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="addNewInvoice"
      aria-labelledby="saveInvoice"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              trending_up
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {t("Save Opportunity")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Define a new opportunity")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="row">
          <div className="col-lg-8">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                <div className="fields-container flex-fill">
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="opportunityType"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Opportunity Type")}
                    </label>
                    <Select
                      id="opportunityType"
                      isClearable
                      styles={customStyles}
                      placeholder={t("Select Opportunity Type")}
                      options={opportunityTypeOptions}
                      value={selectedOppotunityType}
                      onChange={opportunityTypeSelectionHandler}
                    />
                    {errors.type && (
                      <div className="invalid-feedback d-block">
                        {errors.type}
                      </div>
                    )}
                  </div>

                  {selectedOppotunityType && (
                    <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                      <label
                        htmlFor="leadContactSelect"
                        className="d-block fs-sm fw-semibold mb-2 text-dark"
                      >
                        {selectedOppotunityType.value === "lead"
                          ? t("Select Lead")
                          : t("Select Contact")}
                      </label>
                      {selectedOppotunityType.value === "lead" ? (
                        <Select
                          id="leadContactSelect"
                          isClearable
                          styles={customStyles}
                          placeholder={t("Type Lead name or email")}
                          options={leadOptions}
                          value={invoiceLeadValue}
                          onChange={leadSelectionHandler}
                          onInputChange={leadInputChangeHandler}
                        />
                      ) : (
                        <Select
                          id="leadContactSelect"
                          isClearable
                          styles={customStyles}
                          placeholder={t("Type contact name")}
                          options={contactOptions}
                          value={invoiceContactValue}
                          onChange={contactSelectionHandler}
                          onInputChange={contactInputChangeHandler}
                        />
                      )}
                      {errors.selection && (
                        <div className="invalid-feedback d-block">
                          {errors.selection}
                        </div>
                      )}
                    </div>
                  )}

                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="title"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Title")}
                    </label>
                    <input
                      type="text"
                      id="title"
                      className={`form-control fs-sm shadow-none ${
                        errors.title ? "is-invalid" : "border border-gray-300"
                      }`}
                      placeholder={t("Enter opportunity title")}
                      value={title}
                      onChange={(e) => {
                        settitle(e.target.value);
                        if (errors.title)
                          setErrors((prev) => ({ ...prev, title: "" }));
                      }}
                    />
                    {errors.title && (
                      <div className="invalid-feedback">{errors.title}</div>
                    )}
                  </div>

                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="description"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Description")}
                    </label>
                    <textarea
                      id="description"
                      rows="5"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder={t("Enter a detailed description")}
                      value={description}
                      onChange={(e) => setdescription(e.target.value)}
                    ></textarea>
                  </div>

                  <div className="row">
                    <div className="col-3">
                      <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                        <label
                          htmlFor="price"
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          {t("Price")}
                        </label>
                        <p
                          id="price"
                          className={`form-control fs-sm shadow-none ${
                            errors.price
                              ? "is-invalid"
                              : "border border-gray-300"
                          }`}
                        >
                          {totalAmount}
                        </p>
                        {errors.price && (
                          <div className="invalid-feedback d-block">
                            {errors.price}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                        <label
                          htmlFor="promisePercent"
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          {t("Promise Percent")}
                        </label>
                        <input
                          type="number"
                          id="promisePercent"
                          className={`form-control fs-sm shadow-none ${
                            errors.percent
                              ? "is-invalid"
                              : "border border-gray-300"
                          }`}
                          placeholder={t("e.g., 80")}
                          value={promisePercent}
                          onChange={(e) => {
                            setpromisePercent(e.target.value);
                            if (errors.percent)
                              setErrors((prev) => ({ ...prev, percent: "" }));
                          }}
                        />
                        {errors.percent && (
                          <div className="invalid-feedback">
                            {errors.percent}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                        <label
                          htmlFor="followers"
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          {t("Followers")}
                        </label>
                        <Select
                          id="followers"
                          isMulti
                          styles={reactSelectStyle("3px", "6px", true, false)}
                          placeholder={t("Type person name or email")}
                          options={followersOptions}
                          value={followersValue}
                          onChange={followersSelectionHandler}
                          onInputChange={onFollowersInputChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="table-wrapper pb-5 mb-5 border-bottom border-gray">
                    <div className="table-responsive">
                      <table className="table align-middle fs-sm text-nowrap border-0 mb-0">
                        <thead>
                          <tr>
                            <th
                              width="40%"
                              className="bg-transparent fs-md fw-semibold border-0"
                            >
                              {t("Description")}
                            </th>
                            <th className="bg-transparent fs-md fw-semibold border-0">
                              {t("Quantity")}
                            </th>
                            <th className="bg-transparent fs-md fw-semibold border-0">
                              {t("Price")}
                            </th>
                            <th
                              width="15%"
                              className="bg-transparent fs-md fw-semibold border-0"
                            >
                              {t("Tax (IVA)")}
                            </th>
                            <th className="bg-transparent fs-md fw-semibold border-0">
                              {t("Total Amount")}
                            </th>
                            <th className="bg-transparent fs-md fw-semibold border-0"></th>
                          </tr>
                        </thead>
                        <tbody style={{ height: "200px" }}>
                          {invoiceItemsList.map((item, index) => (
                            <tr key={index} style={{ verticalAlign: "top" }}>
                              <td className="border-bottom-0 p-1">
                                <input
                                  type="text"
                                  name="description"
                                  placeholder={t("e.g., Product description")}
                                  className="form-control bg-white shadow-none border-gray-300"
                                  value={item.description}
                                  onChange={(e) =>
                                    changeInvoiceItemsInputs(
                                      index,
                                      "description",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td className="border-bottom-0 p-1">
                                <input
                                  type="number"
                                  className="form-control bg-white shadow-none border-gray-300"
                                  placeholder={t("e.g., 1")}
                                  value={item.quantity}
                                  onChange={(e) =>
                                    changeInvoiceItemsInputs(
                                      index,
                                      "quantity",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td className="border-bottom-0 p-1">
                                <input
                                  type="number"
                                  className="form-control bg-white shadow-none border-gray-300"
                                  placeholder={t("e.g., 100")}
                                  value={item.price}
                                  onChange={(e) =>
                                    changeInvoiceItemsInputs(
                                      index,
                                      "price",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td className="border-bottom-0 p-0">
                                <Select
                                  placeholder="IVA %"
                                  className="w-100 mt-1"
                                  styles={reactSelectStyle(
                                    "5px",
                                    "6px",
                                    false,
                                    false
                                  )}
                                  options={VatOptions}
                                  value={item.taxselectedvalue}
                                  onChange={(val) =>
                                    taxSelectionHandler(index, val)
                                  }
                                />
                              </td>
                              <td className="border-bottom-0 p-1">
                                <span className="form-control bg-white shadow-none border-gray-300">
                                  {item.amount}
                                </span>
                              </td>
                              <td className="border-bottom-0">
                                <Link
                                  className="text-danger"
                                  to="#"
                                  onClick={() => onDeleteInvoiceItem(index)}
                                >
                                  <span className="d-block material-symbols-outlined">
                                    delete
                                  </span>
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="action d-flex gap-1">
                      {" "}
                      <button
                        className="btn btn-outline-primary d-flex align-items-center gap-2"
                        onClick={addNewInvoiceItem}
                      >
                        <span className="material-symbols-outlined me-1">
                          add
                        </span>
                        {t("Add Item")}
                      </button>
                      <button
                        className="btn btn-primary ms-3 d-flex align-items-center gap-2"
                        onClick={saveInvoice}
                        disabled={isSaving}
                        style={{
                          cursor: isSaving ? "not-allowed" : "pointer",
                        }}
                      >
                        {isSaving ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            {t("Saving...")}
                          </>
                        ) : (
                          <>
                            <span className="material-symbols-outlined me-1">
                              save
                            </span>
                            {t("Save Opportunity")}
                          </>
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="table-wrapper pb-3 mb-3 border-bottom border-gray">
                    <div className="table-responsive">
                      <table className="table align-middle fs-sm text-nowrap border-0 mb-0">
                        <tbody>
                          <tr>
                            <td className="p-0 fw-semibold bg-transparent border-0">
                              {t("Total Discount")}
                            </td>
                            <td className="p-0 bg-transparent text-end border-0">
                              {totalDiscount}€
                            </td>
                          </tr>
                          <tr>
                            <td className="p-0 fw-semibold bg-transparent border-0">
                              {t("Total Tax (VAT)")}
                            </td>
                            <td className="p-0 bg-transparent text-end border-0">
                              {totalTax}€
                            </td>
                          </tr>
                          <tr>
                            <td className="p-0 fs-lg fw-semibold bg-transparent border-0">
                              {t("Total Payable Amount")}
                            </td>
                            <td className="p-0 fs-lg fw-semibold text-success bg-transparent text-end border-0">
                              {payableAmount}€
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-4">
            {invoiceLeadValue || invoiceContactValue ? (
              <div className="note-card bg-white border border-gray-300 rounded-15 mb-3 shadow-sm position-relative overflow-hidden">
                <div
                  className="px-4 py-3 border-bottom border-gray-300"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(238, 82, 60, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%)",
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <span className="material-symbols-outlined text-white fs-md">
                        person
                      </span>
                    </div>
                    <div>
                      <h4 className="fw-bold mb-1 text-dark">
                        {invoiceLeadId ? t("Lead") : t("Contact")}{" "}
                        {t("Information")}
                      </h4>
                      <p className="fs-sm text-muted mb-0">
                        {t("Details of the selected ")}
                        {invoiceLeadId ? t("lead") : t("contact")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="note-content pt-4 px-4 pb-4">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <span className="material-symbols-outlined fs-sm text-muted">
                      badge
                    </span>
                    <small className="text-muted fw-semibold">
                      {t("Name")} :{" "}
                      <Link
                        to={
                          invoiceLeadId
                            ? `/admin/crm/lead/information/${invoiceLeadId}`
                            : `/admin/crm/contact/details/timeline/${invoiceContactId}`
                        }
                      >
                        {firstName} {lastName}
                      </Link>
                    </small>
                  </div>
                  <p
                    className="text-dark lh-base mb-0"
                    style={{ fontSize: "0.95rem" }}
                  >
                    <span className="material-symbols-outlined fs-sm text-muted me-2">
                      mail
                    </span>
                    <strong>{t("Email")} : </strong> {emailAddress}
                  </p>
                  <p
                    className="text-dark lh-base mb-0"
                    style={{ fontSize: "0.95rem" }}
                  >
                    <span className="material-symbols-outlined fs-sm text-muted me-2">
                      phone
                    </span>
                    <strong>{t("Phone")} : </strong> {phoneNumber}
                  </p>
                  <p
                    className="text-dark lh-base mb-0"
                    style={{ fontSize: "0.95rem" }}
                  >
                    <span className="material-symbols-outlined fs-sm text-muted me-2">
                      cake
                    </span>
                    <strong>{t("Date of birth")} : </strong> {dateOfBirth}
                  </p>
                  {position && (
                    <p
                      className="text-dark lh-base mb-0"
                      style={{ fontSize: "0.95rem" }}
                    >
                      <span className="material-symbols-outlined fs-sm text-muted me-2">
                        work
                      </span>
                      <strong>{t("Position")} : </strong> {position}{" "}
                      {company && `at ${company}`}
                    </p>
                  )}
                  <p
                    className="text-dark lh-base mb-0"
                    style={{ fontSize: "0.95rem" }}
                  >
                    <span className="material-symbols-outlined fs-sm text-muted me-2">
                      location_on
                    </span>
                    <strong>{t("Location")} : </strong> {address}
                    {city && `, ${city}`}
                    {state && `, ${state}`}
                    {country && `, ${country}`}
                    {zipcode && `, ${zipcode}`}
                  </p>
                </div>
              </div>
            ) : (
              <div className="note-card bg-white border border-gray-300 rounded-15 mb-3 shadow-sm position-relative overflow-hidden">
                <div
                  className="px-4 py-3 border-bottom border-gray-300"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(238, 82, 60, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%)",
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <span className="material-symbols-outlined text-white fs-md">
                        person_add
                      </span>
                    </div>
                    <div>
                      <h4 className="fw-bold mb-1 text-dark">
                        {t("Create new lead")}
                      </h4>
                      <p className="fs-sm text-muted mb-0">
                        {t("Enter details for a new lead")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="note-content pt-4 px-4 pb-4">
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="newLeadName"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      <span className="material-symbols-outlined fs-sm text-muted me-2">
                        badge
                      </span>
                      {t("Name")}
                    </label>
                    <input
                      type="text"
                      id="newLeadName"
                      className={`form-control fs-sm shadow-none ${
                        errors.selection
                          ? "is-invalid"
                          : "border border-gray-300"
                      }`}
                      placeholder={t("e.g., John Doe")}
                      value={newLeadName}
                      onChange={(e) => {
                        setnewLeadName(e.target.value);
                        if (errors.selection)
                          setErrors((prev) => ({ ...prev, selection: "" }));
                      }}
                    />
                  </div>
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="newLeadEmail"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      <span className="material-symbols-outlined fs-sm text-muted me-2">
                        mail
                      </span>
                      {t("Email")}
                    </label>
                    <input
                      type="email"
                      id="newLeadEmail"
                      className={`form-control fs-sm shadow-none ${
                        errors.selection
                          ? "is-invalid"
                          : "border border-gray-300"
                      }`}
                      placeholder={t("e.g., john.doe@example.com")}
                      value={newLeadEmail}
                      onChange={(e) => {
                        setnewLeadEmail(e.target.value);
                        if (errors.selection)
                          setErrors((prev) => ({ ...prev, selection: "" }));
                      }}
                    />
                  </div>
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="newLeadPhone"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      <span className="material-symbols-outlined fs-sm text-muted me-2">
                        phone
                      </span>
                      {t("Phone")}
                    </label>
                    <input
                      type="text"
                      id="newLeadPhone"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder={t("e.g., +1234567890")}
                      value={newLeadPhone}
                      onChange={(e) => setnewLeadPhone(e.target.value)}
                    />
                  </div>
                  {errors.selection && (
                    <div className="invalid-feedback d-block">
                      {errors.selection}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewCrmOpportunityPopup;
